export const sortAuctionValue = (p: { auctionValue: number }) => p.auctionValue
